import { Injectable } from '@angular/core';
import { Config } from '../models/config';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {

  public config: Readonly<Config>;

  public async load() {
    const response = await fetch('assets/config.json');
    this.config = await response.json();
    return this.config;
  }
}
